import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { getUserSalesDesks } from 'state/user';

interface DesksFilterProps {
  deskFilter: number | null;
  onDeskFilterChanged(desk: number | null): void;
}

export function DesksFilter({ deskFilter, onDeskFilterChanged }: DesksFilterProps) {
  const isInternal = useIsInternalUser();
  const desks = useSelector(getUserSalesDesks);
  if (!isInternal || desks.length === 0) {
    return;
  }
  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        data-e2e="desks-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        <i className="icon">desk</i>
        <span className="d-none d-lg-inline">
          {deskFilter === null ? (
            <FormattedMessage id={`blotter.filter.desks.all`} />
          ) : (
            desks.find(desk => desk.id === deskFilter)?.longName
          )}
        </span>
      </DropdownToggle>
      <DropdownMenu role="listbox">
        {
          <SpDropdownItem active={deskFilter === null} onClick={() => onDeskFilterChanged(null)}>
            <FormattedMessage id={`blotter.filter.desks.all`} />
          </SpDropdownItem>
        }
        {desks?.map(desk => (
          <SpDropdownItem
            active={desk.id === deskFilter}
            data-e2e={desks}
            key={desk.id}
            onClick={() => onDeskFilterChanged(desk.id)}
          >
            {desk.longName}
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
}
